const styles = (_theme: Object) => ({
  answerGrid: {
    paddingBottom: 24,
    paddingRight: 16,
  },
  bigQuestion: {
    fontSize: 16,
    paddingBottom: 16,
  },
  cancelButton: {
    marginRight: 10,
  },
  challenges: {
    paddingTop: 0,
  },
  challenge: {
    '&:not(:first-child)': {
      marginTop: 24,
    },
  },
  checkIcon: {
    marginRight: 22,
    color: '#1f74ba',
    paddingBottom: 2,
  },
  dropdownSpace: {
    paddingTop: 1,
    paddingLeft: 10,
    paddingRight: 20,
  },
  fatButton: {
    width: '173px',
    height: '36px',
    backgroundColor: '#1F74BA',
    color: '#ffffff',
    borderRadius: '20px',
    marginLeft: 10,
    '&:hover': {
      backgroundColor: '#356791',
    },
  },
  form: {
    display: 'flex',
    minHeight: '100%',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  formActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '24px 24px 0px 0px',
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  formLabel: {
    height: '52px',
    marginLeft: 1,
    paddingLeft: 24,
    marginRight: 0,
    '& span': {
      width: '100%',
      '&:first-child': {
        display: 'none',
      },
    },
    '&:hover': {
      boxShadow: '1px 1px 3px 0 rgba(30, 30, 30, 0.2)',
    },
  },
  grayText: {
    paddingTop: 1,
    color: '#666666',
  },
  iconLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  littleQuestion: {
    paddingBottom: 10,
  },
  menu: {
    maxHeight: 284,
    overflow: 'scroll',
    // I realize these are technically non-standard, but I figure it's better to have ideal functionality for some users
    // and standard functionality for others than to have everyone adhere to an undesirable standard (looking at you I.E.).
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      width: '7px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      WebkitBoxShadow: '0 0 1px rgba(245, 245, 245, 0.5)',
    },
  },
  messageLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#3e3e3c',
  },
  shadedLabel: {
    height: '52px',
    marginLeft: 1,
    paddingLeft: 24,
    marginRight: 0,
    background: '#fafafa',
    boxShadow: '1px 1px 3px 0 rgba(0, 0, 0, 0.3)',
    '& span': {
      width: '100%',
      '&:first-child': {
        display: 'none',
      },
    },
  },
});

export default styles;
